<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ formatInteger(objEdicao.id) }}</div>
            </div>
            <div class="form-item">
                <label class="label-caption" for="nmep">Nome da EP</label>
                <input type="text" v-model="objEdicao.nmep" id="nmep" maxlength="80" v-uppercase />
            </div>
            <div class="form-item-char20">
                <label class="label-caption" for="cnpj">CNPJ</label>
                <input type="text" v-model="objEdicao.cnpj" id="cnpj" v-cnpj maxlength="18" />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="endereco">Endereço</label>
                <input type="text" v-model="objEdicao.endereco" id="endereco" maxlength="80" v-uppercase />
            </div>
            <div class="form-item-char10">
                <label class="label-caption" for="nmendereco">Número</label>
                <input type="text" class="input-right" v-model="edNmEndereco" id="nmendereco" v-number maxlength="7" />
            </div>
            <div class="form-item">
                <label class="label-caption" for="complemento">Complemento</label>
                <input type="text" v-model="objEdicao.complemento" id="complemento" maxlength="80" v-uppercase />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="bairro">Bairro</label>
                <input type="text" v-model="objEdicao.bairro" id="bairro" maxlength="60" v-uppercase />
            </div>
            <div class="form-item-char10">
                <label class="label-caption" for="cep">CEP</label>
                <input type="text" v-model="objEdicao.cep" id="cep" v-cep maxlength="10" />
            </div>
            <MunicipioSelect class="form-item" v-model:idSelecionado="objEdicao.idmunicipio" />
        </div>

        <div class="row row-space">
            <div class="form-item-telefone">
                <label class="label-caption" for="fone">Telefone</label>
                <input type="text" v-model="objEdicao.fone" id="fone" v-phone maxlength="14" />
            </div>
            <div class="form-item">
                <label class="label-caption" for="email">Email</label>
                <input type="email" v-model="objEdicao.email" id="email" />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="emaildadosproducao">Email de Produção</label>
                <input type="email" v-model="objEdicao.emaildadosproducao" id="emaildadosproducao" />
            </div>
            <div class="form-item">
                <label class="label-caption" for="emailsupervior">Email do Supervisor</label>
                <input type="email" v-model="objEdicao.emailsupervior" id="emailsupervior" />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="rptitulo">Título Relatórios</label>
                <input type="text" v-model="objEdicao.rptitulo" id="rptitulo" />
            </div>
            <div class="form-item">
                <label class="label-caption" for="rpsubtitulo">Subtítulo Relatórios</label>
                <input type="text" v-model="objEdicao.rpsubtitulo" id="rpsubtitulo" />
            </div>

            <div class="form-item-coordenadas">
                <CoordenadasSelect v-model:modelValueLatitude="edLatitude" v-model:modelValueLongitude="edLongitude" />
            </div>
        </div>

        <div class="row-end row-space">
            <label for="ckAtivo">Ativo</label>
            <input type="checkbox" class="input-checkbox" id="ckAtivo" v-model="ckAtivo" />
        </div>

        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>
</template>
  
<script setup>
import { criarEp } from '@/models/ep';
import { onMounted, ref } from 'vue';
import { formatInteger, integerFromString } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { genericPut, getCadastroById } from '@/funcoes/api';
import CoordenadasSelect from '@/components/CoordenadasSelect.vue';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import MunicipioSelect from '@/components/selects/MunicipioSelect.vue';

const emit = defineEmits(['close', 'save']);

const ckAtivo = ref(false);
const edLatitude = ref(0);
const edLongitude = ref(0);
const edNmEndereco = ref(null);
const isLoading = ref(false);
const msgAlerta = ref(null);
const objEdicao = ref(criarEp());

const cancelForm = () => {emit('close');}

const lerDados = async() => {
    try{
        isLoading.value = true;
        msgAlerta.value = null;
        const req = await getCadastroById('ep', globalStore.idep);
        Object.assign(objEdicao.value, req[0]);
        ckAtivo.value                   = objEdicao.value.ativo==='S';
        edNmEndereco.value              = formatInteger(objEdicao.value.nmendereco);
        edLatitude.value                = objEdicao.value.latitude;
        edLongitude.value               = objEdicao.value.longitude;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value=false;}
};

const salvarDados = async() => {
    try {
        if (!objEdicao.value.nmep) throw new Error('Informe o nome');
        isLoading.value             = true;
        msgAlerta.value             = null;
        objEdicao.value.ativo       = ckAtivo.value?'S':'N';
        objEdicao.value.nmendereco  = integerFromString(edNmEndereco.value);
        objEdicao.value.latitude    = !edLatitude.value ? 0 : parseFloat(edLatitude.value.toString().replace(',', '.')) || 0;
        objEdicao.value.longitude   = !edLongitude.value ? 0 : parseFloat(edLongitude.value.toString().replace(',', '.')) || 0;
        const response              = await genericPut('/cad/ep', objEdicao.value);
        if (response.bolok === 1){
            emit('save');
            emit('close');
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally{isLoading.value=false;}
};

onMounted(lerDados);
</script>